import { useState, useEffect } from 'react';
import { getAllInstrumentTypes, getAllFunds } from '../../../services/firestoreService';
import Table from '../../shared/UI/Table';
import Badge from '../../shared/UI/Badge';
import Button from '../../shared/UI/Button';
import SelectField from '../../shared/Forms/SelectField';

export default function InstrumentList({ onAdd, onEdit }) {
  const [instruments, setInstruments] = useState([]);
  const [funds, setFunds] = useState([]);
  const [filterFundId, setFilterFundId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([getAllInstrumentTypes(), getAllFunds()])
      .then(([inst, f]) => { setInstruments(inst); setFunds(f); })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  function fundName(fid) {
    return funds.find(f => f.id === fid)?.name || fid || '—';
  }

  const displayed = filterFundId
    ? instruments.filter(i => i.fund_id === filterFundId)
    : instruments;

  const fundOptions = funds.map(f => ({ value: f.id, label: f.name }));

  const columns = [
    { key: 'name', label: 'Instrument Name' },
    { key: 'fund_id', label: 'Fund', render: row => fundName(row.fund_id) },
    {
      key: 'category',
      label: 'Category',
      render: row => row.category?.replace('_', ' ') || '—',
    },
    {
      key: 'is_active',
      label: 'Status',
      render: row => <Badge text={row.is_active !== false ? 'active' : 'inactive'} />,
    },
    {
      key: 'actions',
      label: 'Actions',
      render: row => <Button size="sm" variant="secondary" onClick={() => onEdit(row)}>Edit</Button>,
    },
  ];

  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <div className="card">
      <div className="card-header">
        <h2>Instrument Types ({displayed.length})</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ width: 220 }}>
            <SelectField
              value={filterFundId}
              onChange={e => setFilterFundId(e.target.value)}
              options={fundOptions}
              placeholder="All funds"
            />
          </div>
          <Button variant="primary" onClick={onAdd}>+ Add Instrument</Button>
        </div>
      </div>
      <Table
        columns={columns}
        data={displayed}
        loading={loading}
        emptyTitle="No instrument types configured"
        emptyMessage="Add instrument types used for deal structuring."
        emptyAction={{ label: '+ Add Instrument', onClick: onAdd }}
      />
    </div>
  );
}
